import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retireService, updateService } from '../services/smr-admin';
import type { ServicePayload } from '../services/smr-admin';
import { serviceKeys, serviceItemsQueryKeyRoot } from './useServicesQuery';
import { planServicesQueryKeyRoot } from './usePlanServiceMutations';
import { serviceKeys as salesJourneyServiceKeys } from '@/features/service-plans/hooks/useServicesQuery';

export const useServiceMutations = () => {
    const queryClient = useQueryClient();
    // Bust every cache holding service data. The promise is returned so the mutation stays
    // pending until the service, plan-service, sales-journey and items refetches reconcile.
    const invalidate = () =>
        Promise.all([
            queryClient.invalidateQueries({ queryKey: serviceKeys.all }),
            queryClient.invalidateQueries({ queryKey: planServicesQueryKeyRoot }),
            queryClient.invalidateQueries({ queryKey: salesJourneyServiceKeys.all }),
            queryClient.invalidateQueries({ queryKey: serviceItemsQueryKeyRoot }),
        ]);

    return {
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: ServicePayload }) => updateService(id, payload),
            onSuccess: invalidate,
        }),
        retireMutation: useMutation({ mutationFn: retireService, onSuccess: invalidate }),
    };
};
